/**
 * Specialty List.
 *
 * @format
 */

const allSpecialties = [
  { name: 'Cardiology', value: 'Cardiology' },
  { name: 'Cardiovascular Surgery', value: 'Cardiovascular Surgery' },
  { name: 'General Surgery', value: 'General Surgery' },
  { name: 'Hepatic Surgery', value: 'Hepatic Surgery' },
  { name: 'Information Technology', value: 'Information Technology' },
  { name: 'Internal Medicine', value: 'Internal Medicine' },
  { name: 'Interventional Oncology', value: 'Interventional Oncology' },
  { name: 'Interventional Radiology', value: 'Interventional Radiology' },
  { name: 'Medical Oncology', value: 'Medical Oncology' },
  { name: 'NA', value: 'NA' },
  { name: 'Neurology', value: 'Neurology' },
  { name: 'Neurosurgery', value: 'Neurosurgery' },
  { name: 'Osteopathic Medicine', value: 'Osteopathic Medicine' },
  { name: 'Pulmonology', value: 'Pulmonology' },
  { name: 'Radiation Oncology', value: 'Radiation Oncology' },
  { name: 'Radiology', value: 'Radiology' },
  { name: 'Surgical Oncology', value: 'Surgical Oncology' },
  { name: 'Thoracic Surgery', value: 'Thoracic Surgery' },
  { name: 'Urology', value: 'Urology' },
  { name: 'Vascular Surgery', value: 'Vascular Surgery' },
  { name: 'Veterinary', value: 'Veterinary' },
];

export const physicianSpecialtyList = [
  { name: 'General Surgery', value: 'General Surgery' },
  { name: 'Hepatic Surgery', value: 'Hepatic Surgery' },
  { name: 'Interventional Oncology', value: 'Interventional Oncology' },
  { name: 'Interventional Pulmonology', value: 'Interventional Pulmonology' },
  { name: 'Interventional Radiology', value: 'Interventional Radiology' },
  { name: 'Medical Oncology', value: 'Medical Oncology' },
  { name: 'Other', value: 'Other' },
  { name: 'Radiation Oncology', value: 'Radiation Oncology' },
  { name: 'Radiology', value: 'Radiology' },
  { name: 'Surgical Oncology', value: 'Surgical Oncology' },
  { name: 'Urology', value: 'Urology' },
];

export const specialtyList = {
  'Chief/Dept Administrator': allSpecialties,
  'IT - Management': allSpecialties,
  'IT - Technician': allSpecialties,
  Nurse: allSpecialties,
  'Nurse - Manager': allSpecialties,
  'VIS Physician': physicianSpecialtyList,
  Physician: allSpecialties,
  'Therapist/Technician/Technologist/Operator': allSpecialties,
  'Therapist - Chief': allSpecialties,
  'Veterinary Staff': allSpecialties,
};
